import { http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { Team } from '@nxtpeople/nxt-vue-library';
import { LocationQuery } from 'vue-router';

class TeamService {
   async getTeams(query: any) {
      return await http.get<PaginatedResponse<Team>>(`/teams`, { params: { ...query } }).then((response) => response.data);
   }
   async getTeam(teamId: number, query?: LocationQuery) {
      const response = await http.get<Team>(`/teams/${teamId}`, { params: { ...query } });
      return response.data;
   }
}

export default new TeamService();
